function getUploadFileBlocks(scope, selector) {
  const uploadFileBlocks = [];

  if (scope?.matches?.(selector)) {
    uploadFileBlocks.push(scope);
  }

  if (scope?.querySelectorAll) {
    uploadFileBlocks.push(...scope.querySelectorAll(selector));
  }

  return uploadFileBlocks;
}

function uploadFile(scope = document) {
  const uploadFileBlocksArr = getUploadFileBlocks(
    scope,
    '[data-upload-file-animation]'
  );

  uploadFileBlocksArr.forEach((fileUpload) => {
    if (fileUpload.classList.contains('is-init-upload-file-animation')) {
      return;
    }

    fileUpload.classList.add('is-init-upload-file-animation');

    fileUpload.addEventListener('dragover', function () {
      this.classList.add('drag');
      this.classList.remove('drop', 'done');
    });

    fileUpload.addEventListener('dragleave', function () {
      this.classList.remove('drag');
    });

    fileUpload.addEventListener('drop', start, false);
    fileUpload.addEventListener('change', start, false);

    function start() {
      this.classList.remove('drag');
      this.classList.add('drop');
      setTimeout(() => this.classList.add('done'), 650);
      setTimeout(function () {
        const inputs = document.querySelectorAll(
          '.meta-upload-file__input input.error'
        );
        if (!inputs.length) return;

        inputs.forEach((input) => {
          input.classList.remove('error');

          const errorWrapper = input.closest('.error');
          if (errorWrapper) errorWrapper.classList.remove('error');

          const uploadWrapper = input.closest('.meta-upload-file');
          if (uploadWrapper) uploadWrapper.classList.remove('error');

          const errorTextEl = uploadWrapper?.querySelector('.error-text');
          if (errorTextEl) {
            errorTextEl.style.opacity = '0';
            errorTextEl.style.overflow = 'hidden';
            errorTextEl.style.maxHeight = '0px';
            errorTextEl.style.height = '0px';
          }
        });
      }, 650);
    }

    fileUpload.addEventListener('click', function () {
      fileUpload.classList.remove('error');
      const errorsElArr = fileUpload.querySelectorAll('.error');
      for (let i = 0; i < errorsElArr.length; i++) {
        errorsElArr[i].classList.remove('error');
      }
      const errorTextEl = fileUpload.querySelector('.error-text');
      if (errorTextEl) {
        errorTextEl.style.opacity = '0';
        errorTextEl.style.overflow = 'hidden';
        errorTextEl.style.maxHeight = '0px';
        errorTextEl.style.height = '0px';
      }
    });
  });
}

window.uploadFile = uploadFile;

function initMetaUploadFile(scope = document) {
  const metaUploadFileArr = getUploadFileBlocks(scope, '.meta-upload-file');

  metaUploadFileArr.forEach((metaUploadFile) => {
    if (!metaUploadFile.classList.contains('is-init-meta-upload-file')) {
      metaUploadFile.classList.add('is-init-meta-upload-file');

      const fileNameEl = metaUploadFile.querySelector(
        '[data-meta-upload-file-name]'
      );
      const inputEl = metaUploadFile.querySelector('input');

      if (inputEl) {
        const updateFileName = () => {
          const file = inputEl.files?.[0];
          metaUploadFile.classList.toggle('is-file-selected', Boolean(file));

          if (fileNameEl) {
            fileNameEl.textContent = file ? file.name : 'No file selected';
          }
        };

        updateFileName();
        inputEl.addEventListener('change', updateFileName);
      }
    }
  });
}

window.initMetaUploadFile = initMetaUploadFile;

function initUploadFileBlocks(scope = document) {
  uploadFile(scope);
  initMetaUploadFile(scope);
}

initUploadFileBlocks();

if (typeof MutationObserver !== 'undefined' && document.body) {
  const uploadFileObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== 1) {
          return;
        }

        if (
          node.matches?.('.meta-upload-file') ||
          node.querySelector?.('.meta-upload-file')
        ) {
          initUploadFileBlocks(node);
        }
      });
    });
  });

  uploadFileObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
